import { APPConfig } from 'config/appConfig'
import { observable } from 'mobx'
import contentStack from 'src/api/contentStack'
import { getLocaleCodeFromUrl } from 'src/utils'

class LinkFromContentStack {
  @observable termAndConditionLink = ''
  fetchTermsConditionsLink = async () => {
    const { clientDomainName = '' } = APPConfig?.getAppConfig() || {}
    const isDomainStatus = ['test.nuskin.com', 'www.nuskin.com'].includes(
      clientDomainName
    )
    let domainName = clientDomainName
    if (!isDomainStatus) {
      domainName = 'www.nuskin.com'
    }
    let locale = getLocaleCodeFromUrl() || ''

    locale = locale?.split?.('_')?.reverse?.().join?.('-') || 'US-en'
    let uid = 'blta895a523c9556e91'
    try {
      const response = await contentStack.getQualificationReference(
        'subscriptions_modal',
        uid,
        locale
      )
      if (response) {
        const link = response?.footer?.terms_conditions?.href || ''
        const modifiedLink = link?.includes('https://')
          ? link
          : `https://${domainName}${link}`
        this.termAndConditionLink = modifiedLink
        return this.termAndConditionLink
      }
    } catch (error) {
      console.error('Error fetching terms and conditions link:', error)
      return ''
    }
  }
}

const linkFromContentStack = new LinkFromContentStack()

export { linkFromContentStack }
export default linkFromContentStack
